<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2 class="mb-2">Budget Plan {{ detail.title }}</h2>
                <!-- Text -->
                <p class="text-muted mb-md-0">
                  <small>Version {{ detail?.version }} </small>
                </p>
                <p class="text-muted mb-md-0" v-if="updatedAt != ''">
                  <small>Last update : {{ updatedAt }} </small>
                </p>
                <p class="text-muted mb-md-0" v-if="updatedAt != ''">
                  <small>by {{ updatedBy }}</small>
                </p>
              </div>
              <div class="col-12 col-md-auto"></div>
            </div>
          </div>
        </div>
        <div class="row" v-if="isLoading">
          <div class="col-12">
            <div class="card">
              <div class="row row-col-5 gx-3 gy-5 card-body">
                <div class="col">
                  <div class="col-12 col-lg-6">
                    <b-skeleton animation="wave" width="45%"></b-skeleton>
                    <b-skeleton animation="wave" width="75%"></b-skeleton>
                  </div>
                </div>
                <div class="col">
                  <div class="col-12 col-lg-6">
                    <b-skeleton animation="wave" width="45%"></b-skeleton>
                    <b-skeleton animation="wave" width="75%"></b-skeleton>
                  </div>
                </div>
                <div class="col">
                  <div class="col-12 col-lg-6">
                    <b-skeleton animation="wave" width="45%"></b-skeleton>
                    <b-skeleton animation="wave" width="75%"></b-skeleton>
                  </div>
                </div>
                <div class="col">
                  <div class="col-12 col-lg-6">
                    <b-skeleton animation="wave" width="45%"></b-skeleton>
                    <b-skeleton animation="wave" width="75%"></b-skeleton>
                  </div>
                </div>
                <div class="col">
                  <div class="col-12 col-lg-6">
                    <b-skeleton animation="wave" width="45%"></b-skeleton>
                    <b-skeleton animation="wave" width="75%"></b-skeleton>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <div class="card-body row">
                <div class="col-12 col-md-6">
                  <div class="card">
                    <div class="row gx-3 gy-5 card-body">
                      <div class="col-12 col-lg-6">
                        <b-skeleton animation="wave" width="45%"></b-skeleton>
                        <b-skeleton animation="wave" width="75%"></b-skeleton>
                      </div>
                      <div class="col-12 col-lg-6">
                        <b-skeleton animation="wave" width="45%"></b-skeleton>
                        <b-skeleton animation="wave" width="75%"></b-skeleton>
                      </div>
                      <div class="col-12 col-lg-6">
                        <b-skeleton animation="wave" width="45%"></b-skeleton>
                        <b-skeleton animation="wave" width="75%"></b-skeleton>
                      </div>
                      <div class="col-12 col-lg-6">
                        <b-skeleton animation="wave" width="45%"></b-skeleton>
                        <b-skeleton animation="wave" width="75%"></b-skeleton>
                      </div>
                      <div class="col-12 col-lg-6">
                        <b-skeleton animation="wave" width="45%"></b-skeleton>
                        <b-skeleton animation="wave" width="75%"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="card">
                    <div class="card-body d-flex flex-column">
                      <div class="mt-2">
                        <b-skeleton animation="wave" width="100%"></b-skeleton>
                        <b-skeleton animation="wave" width="100%"></b-skeleton>
                      </div>
                      <div class="mt-2">
                        <b-skeleton animation="wave" width="100%"></b-skeleton>
                        <b-skeleton animation="wave" width="100%"></b-skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card"></div>
          </div>
        </div>
        <div class="row" v-if="!isLoading">
          <div class="col-12">
            <div class="card">
              <div class="row row-col-5 gx-3 gy-5 card-body">
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-clipboard"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Budget title</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detail.title }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-home"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Department</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detail.fund_center?.department_code }} - {{ detail?.departments }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-credit-card"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Fund Center</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detail.fund_center?.fund_center }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-calendar"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Year</h4>
                      <small class="text-body-secondary"
                        ><span> {{ detail.year }}</span>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row align-items-center">
                    <div class="col-auto">
                      <div class="avatar avatar-sm">
                        <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                          <i class="fe fe-dollar-sign"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col ms-n2">
                      <h4 class="mb-1 font-weight-bold">Total OPEX + CAPEX</h4>
                      <small class="text-body-secondary"
                        ><span> {{ budgetPlanTotal }}</span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <div class="card-body row">
                <div class="col-12 col-md-6">
                  <div class="card">
                    <div class="row gx-3 gy-5 card-body">
                      <div class="col-12 col-lg-6">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Created At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ createdAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Created By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ createdBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Updated At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ updatedAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Updated By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ updatedBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail.locked">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Locked At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ lockedAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail.locked">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Locked By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ lockedBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail.all_version?.length != detail.version">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Cloned At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ clonedAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail.all_version?.length != detail.version">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Cloned By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ clonedBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail?.histories?.some((h) => h.activity == 'APPROVE')">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Approved At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ approvedAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail?.histories?.some((h) => h.activity == 'APPROVE')">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Approved By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ approvedBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail?.histories?.some((h) => h.activity == 'DISAPPROVE')">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-calendar"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Disapproved At</h4>
                            <small class="text-body-secondary"
                              ><span> {{ disapprovedAt }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-6" v-if="detail?.histories?.some((h) => h.activity == 'DISAPPROVE')">
                        <div class="row align-items-center">
                          <div class="col-auto">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                <i class="fe fe-user"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col ms-n2">
                            <h4 class="mb-1 font-weight-bold">Disapproved By</h4>
                            <small class="text-body-secondary"
                              ><span> {{ disapprovedBy }}</span>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="card">
                    <div class="card-body d-flex flex-column">
                      <template v-for="version in detail.all_version">
                        <a v-if="id != version.id" class="btn mb-3 btn-outline-primary" @click="goToHistory(version.id)"
                          >Version {{ version.version }} <span class="ml-3 fe fe-check-circle" v-if="version.approved" title="Approved"></span
                        ></a>
                        <a v-else class="btn mb-3 btn-primary"
                          >Version {{ version.version }} <span class="ml-3 fe fe-check-circle" v-if="version.approved" title="Approved"></span
                        ></a>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <div class="card-header"><h4 class="mb-1 font-weight-bold">Activity Log</h4></div>
              <div class="card-body">
                <vue-good-table
                  :line-numbers="true"
                  :columns="columns"
                  :rows="histories"
                  :sort-options="{
                    enabled: true,
                  }"
                  :total-rows="histories?.length || 0"
                  :pagination-options="{
                    enabled: true,
                    perPage: body.perPage,
                  }"
                  style-class="vgt-table border-0 table"
                >
                  <div slot="emptystate" class="text-center font-size-14">No data available</div>
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'action'">
                      <button
                        class="btn btn-outline-info"
                        v-if="props.row.changes"
                        type="button"
                        @click="showModalChanges(props.row.changes?.groupedChanges, props.row.activity)"
                      >
                        <span class="fe fe-eye"></span>
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
        <!-- Body -->
      </div>

      <!-- Body -->
    </div>
    <!-- / .header -->
    <ModalDetailHistory
      @show-modal="showModalChanges"
      @hide-modal="hideModalChanges"
      ref="modalNotification"
      :changes="changes"
      :type="historyType"
    />
  </div>
</template>

<script>
import department from '@/store/modules/department';
import store from '@/store';
import axiosIns from '@/api/axios';
import moment from 'moment';
import ModalDetailHistory from './components/ModalDetailHistory.vue';

export default {
  components: { ModalDetailHistory },
  computed: {
    detail() {
      return this.$store.getters['budgetPlan/detail'];
    },
    histories() {
      return this.detail?.histories;
    },
    budgetPlanTotal() {
      return `RP. ${this.convertNumber(parseFloat(this.detail?.capex_total) + parseFloat(this.detail?.opex_total)) || 0}`;
    },
    createdAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'CREATE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'CREATE').created_at).format('DD MMM YYYY HH:mm')
          : moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    createdBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'CREATE')
          ? this.detail?.histories.find((e) => e.activity == 'CREATE')?.user?.fullname || 'System'
          : 'System'
        : 'System';
    },
    updatedAt() {
      return this.detail?.histories?.length > 0
        ? moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    updatedBy() {
      return this.detail?.histories?.length > 0 ? this.detail?.histories[0]?.user?.fullname || 'System' : 'System';
    },
    clonedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'CLONE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'CLONE').created_at).format('DD MMM YYYY HH:mm')
          : moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    clonedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'CLONE')
          ? this.detail?.histories.find((e) => e.activity == 'CLONE')?.user?.fullname || 'System'
          : 'System'
        : 'System';
    },
    lockedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'LOCK')
          ? moment(this.detail?.histories.find((e) => e.activity == 'LOCK').created_at).format('DD MMM YYYY HH:mm')
          : moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    lockedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'LOCK')
          ? this.detail?.histories.find((e) => e.activity == 'LOCK')?.user?.fullname || 'System'
          : 'System'
        : 'System';
    },
    approvedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'APPROVE')
          ? this.detail?.histories.find((e) => e.activity == 'APPROVE')?.user?.fullname || 'System'
          : 'System'
        : 'System';
    },
    approvedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'APPROVE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'APPROVE').created_at).format('DD MMM YYYY HH:mm')
          : moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
    disapprovedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'DISAPPROVE')
          ? this.detail?.histories.find((e) => e.activity == 'DISAPPROVE')?.user?.fullname || 'System'
          : 'System'
        : 'System';
    },
    disapprovedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'DISAPPROVE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'DISAPPROVE').created_at).format('DD MMM YYYY HH:mm')
          : moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment().format('DD MMM YYYY HH:mm');
    },
  },
  data() {
    return {
      listBudget: '',
      listViewer: '',
      body: {
        search: '',
        page: 1,
        perPage: 10,
      },
      columns: [
        {
          label: 'Activity Type',
          field: 'activity',
          sortable: true,
          thClass: 'table-header w-auto text-muted font-weight-bold',
          tdClass: 'w-autocolor-secondary align-middle',
        },
        {
          label: 'Activity Date',
          field: ({ created_at }) => moment(created_at).format('DD MMMM YYYY HH:mm'),
          sortable: true,
          thClass: 'table-header w-auto text-muted font-weight-bold',
          tdClass: 'w-autocolor-secondary align-middle',
        },
        {
          label: 'User',
          field: 'user.fullname',
          sortable: true,
          thClass: 'table-header w-auto text-muted font-weight-bold',
          tdClass: 'w-autocolor-secondary align-middle',
        },
        {
          label: 'Note',
          field: 'notes',
          sortable: false,
          thClass: 'table-header w-auto text-muted font-weight-bold',
          tdClass: 'w-autocolor-secondary align-middle',
        },
        {
          label: 'Action',
          field: 'action',
          sortable: false,
          thClass: 'table-header w-auto text-muted font-weight-bold',
          tdClass: 'w-autocolor-secondary align-middle',
        },
      ],
      role_id: '',
      id: '',
      isLoading: false,
      changes: {},
      historyType: '',
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const id = this.$router.currentRoute.query.id;
      await this.$store.dispatch('budgetPlan/GET_BUDGET_DETAIL', id);
      this.id = id;
    },
    goToHistory(id) {
      this.isLoading = true;
      this.$router
        .push({
          name: 'budget_plan_histories',
          query: { id },
        })
        .then(() => {
          this.getDetail()
            .then(() => {
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        });
    },
    historyBack() {
      this.$router.push({
        name: 'budget_plan',
      });
    },
    convertNumber(dat) {
      return parseInt(dat)
        .toString()
        .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    },
    showModalChanges(changes, type) {
      console.log(changes);
      this.changes = changes;
      this.historyType = type;
      setTimeout(() => {
        this.$bvModal.show('modal-detailHistory');
      }, 100);
    },
    hideModalChanges() {
      this.changes = {};
      this.$bvModal.hide('modal-detailHistory');
    },
  },
};
</script>

<style>
.bg-gray {
  background: #dad9d9 !important;
}

.tables-budget td:first-child,
.tables-budget td:nth-last-child(3),
.tables-budget td:nth-last-child(2),
.tables-budget td:last-child {
  /* text-align: center; */
}

.tables-budget > :not(caption) > * > * {
  padding: 0.5rem !important;
}

/* th:first-child+th+th,
  td:first-child+td+td {
    position: sticky;
    left: 0px;
    z-index: 3;
  } */

/* .opex-first th:first-child+th+th,
  .opex-first td:first-child+td+td {
    position: sticky;
    left: 0px;
    z-index: 3;
  }
  .capex th:first-child+th+th,
  .capex td:first-child+td+td {
    position: sticky;
    left: 0px;
    z-index: 3;
  }

  .capex-gl th:first-child+th+th,
  .capex-gl td:first-child+td+td {
    position: sticky;
    left: 0px;
    z-index: 3;
  }

  .capex td:first-child + td + td {
    background-color: #fff !important;
  }

  .opex td:first-child + td + td {
    background-color: #fff !important;
  } */
</style>
